import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon.js';
import Button from './Button.js';
import Tooltip from './Tooltip.js';
import { g as getZIndex, z as zIndexProps } from './zIndex-f4f0b1c8.js';
import { a as addClassNames } from './classNames-6a4763fd.js';
import './spacing-d13ff368.js';
import './componentEl-33ff2aeb.js';

function FabAdditional({
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "st_btn--fab-group"
  }, children);
}

function FabButton(_ref) {
  let {
    icon,
    simple,
    toolTipContent,
    inverted,
    children,
    zIndex
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["icon", "iconSize", "simple", "toolTipContent", "inverted", "children", "zIndex"]);

  let button;

  if (toolTipContent) {
    button = /*#__PURE__*/React.createElement(Tooltip, {
      key: "st_btn--fab-tooltip-" + (otherProps.key || 'default')
    }, /*#__PURE__*/React.createElement(Tooltip.Content, {
      position: "left"
    }, toolTipContent), /*#__PURE__*/React.createElement(Tooltip.Trigger, null, /*#__PURE__*/React.createElement(Button, _extends({
      className: "st_btn--fab " + (inverted ? 'st_btn--fab-inverted' : '')
    }, otherProps), /*#__PURE__*/React.createElement(Icon, {
      type: icon,
      size: "md"
    }))));
  } else {
    button = /*#__PURE__*/React.createElement(Button, _extends({
      className: "st_btn--fab " + (inverted ? 'st_btn--fab-inverted' : '')
    }, otherProps), /*#__PURE__*/React.createElement(Icon, {
      type: icon,
      size: "md"
    }));
  }

  if (simple) {
    return button;
  }

  let cssClasses = ['st_btn--fab-container'];
  if (zIndex) cssClasses = addClassNames(getZIndex(zIndex), cssClasses);
  return /*#__PURE__*/React.createElement("div", {
    className: cssClasses.join(' ')
  }, button, children);
}

FabButton.propTypes = {
  /**  name of icon */
  icon: PropTypes.string.isRequired,

  /** icon size */
  iconSize: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg']),

  /** boolen to specify if just the button is returned */
  simple: PropTypes.bool,

  /** Changes inverts the style */
  inverted: PropTypes.bool,

  /** Tooltip Content */
  toolTipContent: PropTypes.string,

  /**
   * z-index for button container.
   * Ignored for single buttons. One of `minor`, `mid`, `mad`, `major`, `top` */
  zIndex: zIndexProps
};
FabButton.defaultProps = {
  iconSize: 'mlg',
  simple: false,
  inverted: false,
  toolTipContent: '',
  zIndex: 'major'
};
FabButton.FabAdditional = FabAdditional;
FabButton.FabAdditional.displayName = 'FabButton.FabAdditional';

export default FabButton;
